export { default } from "./useMediaQuery.js";
export * from "./useMediaQuery.js";